import { createSlice } from "@reduxjs/toolkit";
// redux
import { batch } from "src/redux/store";
import { recursiveCheckTaskById, updateOrderRefreshStatus } from "src/redux/slices/task";
// sections
// import { getRequestBody } from "src/sections/transaction/utility/format-data";
// utils
import { openFile } from "src/utils/handle-task";
import { trimObject } from "src/utils/format-object";

// ----------------------------------------------------------------------

const defaultTransactionFilter = {
    transaction_type: "all",
    start_date: "",
    end_date: "",
    page: 1,
    page_size: 25,
    total: 0
};

const slice = createSlice({
    name: "transaction",
    initialState: {
        isLoading: false,
        error: null,
        // ----------------------------------
        transactionFilter: defaultTransactionFilter,
    },
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        hasError(state, action) {
            state.isLoading = false;
            //
            state.error = action.payload;
        },

        clearError(state) {
            state.error = null;
        },

        updateTransactionListFilter(state, action) {
            state.transactionFilter = {
                ...state.transactionFilter,
                ...action.payload
            };
        },

        resetTransactionListFilter(state) {
            state.transactionFilter = {
                ...state.transactionFilter,
                //
                transaction_type: "all",
                start_date: "",
                end_date: "",
                page: 1,
                page_size: 25,
            };
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    updateTransactionListFilter,
    resetTransactionListFilter,
    //
    clearError
} = slice.actions;

// ----------------------------------------------------------------------
